import {
  AudisService, CsvParserService,
  DeviceService,
  DownloadService, ErrorService, FormattingService, IbanValidationService,
  IconService, KeycloakInterceptorService, KeycloakLv1871Service, MaterialDateAdapter,
  MomentService, NotificationService, StyleService,
  SvgIconService, ThemeService, TranslationScopeRef, TranslationService,
  UiConfigService,
  UiConfigServiceMock, WindowRef
} from '@lv1871/core';
import {EncryptionService} from './encryption.service';

export const ALL_SERVICES = [
  UiConfigService,
  UiConfigServiceMock,
  DeviceService,
  DownloadService,
  FormattingService,
  IconService,
  MomentService,
  SvgIconService,
  ThemeService,
  TranslationService,
  TranslationScopeRef,
  WindowRef,
  KeycloakLv1871Service,
  StyleService,
  IbanValidationService,
  AudisService,
  CsvParserService,
  KeycloakInterceptorService,
  ErrorService,
  NotificationService,
  EncryptionService
];
